import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=96b8c2b0&scoped=true&"
import script from "./FeedbackCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackCard.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=96b8c2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b8c2b0",
  null
  
)

export default component.exports